module.exports = __webpack_public_path__ + "img/oneBlue.61dbae8b.jpg";